export default __webpack_public_path__ + "static/media/qa-like-icon.308b5926.svg";